/** @typedef {{exportTemplate: import('../state').ExportTemplateState}} RootState */

/**
 * @param {RootState} state
 * @param {number} templateId */
export const isTemplateIdFavourite = (state, templateId) =>
  state.exportTemplate.favouriteTemplateId === templateId;

/**
 * @param {RootState} state */
export const isFavouriteLoading = state =>
  state.exportTemplate.isFavouriteLoading;

/**
 * @param {RootState} state */
export const getFavouriteTemplateId = state =>
  state.exportTemplate.favouriteTemplateId;
